import { render, staticRenderFns } from "./InputBalance.vue?vue&type=template&id=23372a9e&scoped=true"
import script from "./InputBalance.vue?vue&type=script&lang=js"
export * from "./InputBalance.vue?vue&type=script&lang=js"
import style0 from "./InputBalance.vue?vue&type=style&index=0&id=23372a9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23372a9e",
  null
  
)

export default component.exports